import { useEffect } from 'react';

/**
 * Automatically sends a message through a data channel when the payload changes
 * @param channel - The RTCDataChannel to send through
 * @param type - The message type identifier
 * @param payload - The message payload (will be JSON stringified)
 */
export function useDataChannelMessage(
  channel: RTCDataChannel | undefined,
  type: string,
  payload: unknown
) {
  useEffect(() => {
    if (!channel || channel.readyState !== 'open') return;

    channel.send(JSON.stringify({
      type,
      payload
    }));
  }, [channel, type, payload]);
}
